// src/models/authModels.ts

// Response from the login API
export class LoginResponse {
  accessToken?: string;
  refreshToken?: string;
  user?: {
    id: number;
    name: string;
  };
  subscriptionDetails?: {
    platform: string;
    status: string;
    expiryDate: string;
  };
  constructor(data: Partial<LoginResponse> = {}) {
    this.accessToken = data.accessToken;
    this.refreshToken = data.refreshToken;
    this.user = data.user ? { ...data.user } : undefined;
    this.subscriptionDetails = data.subscriptionDetails ? { ...data.subscriptionDetails } : undefined;
  }
}

  
  // Response from the OTP verification API
  export interface VerifyOtpResponse {
    success: boolean;
    message?: string;
    userId?: string;
  }
  
  // Response from the delete account API
  export class DeleteAccountResponse {
    success: boolean;
    message?: string;

    constructor(success: boolean, message?: string) {
      this.success = success
      this.message = message
    }
  }

  export {};
  